module.exports = __webpack_public_path__ + "static/media/nashville.85e78f54.png";